const prefix = 'workspace-table';

export const workspaceTableI18n = {
    name: {
        id: `${prefix}.name`,
        defaultMessage: 'Name',
    },
    description: {
        id: `${prefix}.description`,
        defaultMessage: 'Description',
    },
    access: {
        id: `${prefix}.access`,
        defaultMessage: 'Access',
    },
    status: {
        id: `${prefix}.status`,
        defaultMessage: 'Status',
    },
    createdAt: {
        id: `${prefix}.createdAt`,
        defaultMessage: 'Created At',
    },
    datasets: {
        id: `${prefix}.datasets`,
        defaultMessage: 'Datasets',
    },
    users: {
        id: `${prefix}.users`,
        defaultMessage: 'Users',
    },
    noWorkspacesTitle: {
        id: `${prefix}.noWorkspacesTitle`,
        defaultMessage: 'No workspaces',
    },
    loadErrorTitle: {
        id: `${prefix}.loadErrorTitle`,
        defaultMessage: 'Could not load workspaces',
    },
    loadErrorMessage: {
        id: `${prefix}.loadErrorMessage`,
        defaultMessage: 'Refresh the page to try again.',
    },
} as const;
